
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import i18n from '@/lang/i18n'
import { isLogout, isTokenExemptPage } from '@/js/commons/commons'

import Home from '@/js/components/Home'
import Login from '@/js/components/Authentication/Login'
import SendResetLink from '@/js/components/Authentication/ForgotPassword/SendResetLink'
import ChangePassword from '@/js/components/Authentication/ForgotPassword/ChangePassword'
import ChangedPassword from '@/js/components/Authentication/ForgotPassword/ChangedPassword'
import FirstTimeResetPassword from '@/js/components/Authentication/FirstTimeResetPassword'
import ContactForm from '@/js/components/Contact/ContactForm'
import ContactConfirm from '@/js/components/Contact/ContactConfirm'
import ContactFinished from '@/js/components/Contact/ContactFinished'
import NotFound from '@/js/components/NotFound'
import Patient from '@/js/components/Patient/Patient'
import PDF from '@/js/components/PDF/PDF'
import HomeCarePDF from '@/js/components/PDF/HomeCarePDF/HomeCarePDF'
import VaccinationPDF from '@/js/components/PDF/VaccinationPDF/VaccinationPDF'
import AllergyPDF from '@/js/components/PDF/AllergyPDF/AllergyPDF'
import NotificationList from '@/js/components/Notification/List'
import NotificationDetail from '@/js/components/Notification/Detail'
import NotificationRegionList from '@/js/components/Notification/RegionList'
import NotificationRegionDetail from '@/js/components/Notification/RegionDetail'
import NotificationManagement from '@/js/components/Notification/Management'
import NotificationForm from '@/js/components/Notification/Form'
import LegalTermsofuse from '@/js/components/LegalTermsofuse'
import Info from '@/js/components/Info'
import Settings from '@/js/components/Settings'
import PatientList from '@/js/components/PatientList'
import PatientDetail from '@/js/components/Patient/PatientDetail'
import SurveyComplete from '@/js/components/SurveyComplete'
import ErrorCheck from '@/js/components/ErrorCheck'
import Survey from '@/js/components/Survey/Survey'
import MaintenanceMode from '@/js/components/MaintenanceMode'
import ChangeEmailForm from '@/js/components/ChangeEmailForm'
import ConfirmChangeEmail from '@/js/components/ConfirmChangeEmail'
import VerifyCode from '@/js/components/Authentication/VerifyCode'
import RegisterPhoneNumber from '@/js/components/Authentication/RegisterPhoneNumber'
import ConfirmPhoneNumber from '@/js/components/Authentication/ConfirmPhoneNumber'

Vue.use(VueRouter)

const routes = [
  {
    name: 'home',
    path: '/',
    component: Home,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.typeOfUser === 'pharmacy') {
        next('/patients')
      }
      else {
        next()
      }
    },
    meta: {
      layout: 'member',
      auth: true,
      title: 'nanacara for Doctor'
    },
  },
  {
    name: 'Login',
    path: '/login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.token) {
        if(to.query.hasOwnProperty('continue')) {
          next(decodeURIComponent(to.query.continue))
        }
        else{
          next('/')
        }
      }
      next()
    },
    meta: {
      layout: 'nonmember',
      auth: undefined,
      title: i18n.t('login')
    }
  },
  {
    name: "verify",
    path: "/verify",
    component: VerifyCode,
    beforeEnter: (to, from, next) => {
			if (store.state.auth.token) {
				next("/")
			}
			next()
		},
    meta: {
      layout: 'nothing',
      title: i18n.t('verify_code.title'),
      auth: false,
    }
  },
  {
    name: 'Send Reset Link',
    path: '/send-reset-link',
    component: SendResetLink,
    meta: {
      layout: 'nonmember',
      auth: false,
      title: i18n.t('resetting_a_password')
    }
  },
  {
    name: 'Change Password',
    path: '/change-password',
    component: ChangePassword,
    meta: {
      layout: 'nonmember',
      auth: false,
      title: i18n.t('change_password')
    }
  },
  {
    name: 'Changed Password',
    path: '/changed-password',
    component: ChangedPassword,
    meta: {
      layout: 'nonmember',
      auth: false,
      title: i18n.t('change_password')
    }
  },
  {
    name: 'FirstTimeResetPassword',
    path: '/first-time-reset',
    component: FirstTimeResetPassword,
    meta: {
      layout: 'nonmember',
      auth: false,
      title: i18n.t('login')
    }
  },
  {
    name: 'ContactForm',
    path: '/contact-form',
    component: ContactForm,
    meta: {
      layout: store?.state?.auth?.token ? 'member' : 'default',
      auth: undefined,
      title: i18n.t('contact')
    }
  },
  {
    name: 'ContactConfirm',
    path: '/contact-confirm',
    component: ContactConfirm,
    meta: {
      layout: store.state.auth.token ? 'member' : 'default',
      auth: undefined,
      title: i18n.t('contact')
    }
  },
  {
    name: 'ContactFinished',
    path: '/contact-finished',
    component: ContactFinished,
    meta: {
      layout: store.state.auth.token ? 'member' : 'default',
      auth: undefined,
      title: i18n.t('contact')
    }
  },
  {
    name: 'Patient Info',
    path: '/patient',
    component: Patient,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.typeOfUser === 'pharmacy') {
        next('/patients')
      }
      else {
        next()
      }
    },
    meta: {
      layout: 'member',
      auth: true,
      title: i18n.t('patient_information')
    }
  },
  {
    name: 'Patient List',
    path: '/patients',
    component: PatientList,
    meta: {
      layout: 'member',
      auth: true,
      title: i18n.t('patient_list')
    },
  },
  {
    name: 'Patient Detail',
    path: '/patient/:childId',
    component: PatientDetail,
    meta: {
      layout: 'member',
      auth: true,
      title: i18n.t('patient_information')
    }
  },
  {
    name: 'PDF',
    path: '/pdf',
    component: PDF,
    meta: {
      layout: 'pdf',
      title: "PDF",
      auth: true
    }
  },
  {
    name: 'HomeCarePDF',
    path: '/homecare-pdf',
    component: HomeCarePDF,
    meta: {
      layout: 'pdf',
      title: i18n.t('home_care_notebook'),
      auth: true
    }
  },
  {
    name: 'VaccinPDF',
    path: '/vaccin-pdf',
    component: VaccinationPDF,
    meta: {
      layout: 'pdf',
      title: i18n.t('vaccination'),
      auth: true
    }
  },
  {
    name: 'AllergyPDF',
    path: '/allergy-pdf',
    component: AllergyPDF,
    meta: {
      layout: 'pdf',
      title: i18n.t('allergy'),
      auth: true
    }
  },
  {
    name: 'Notifications',
    path: '/notifications',
    component: NotificationList,
    meta: {
      layout: 'member',
      title: i18n.t('notification'),
      auth: true
    }
  },
  {
    name: 'Notification Detail',
    path: '/notifications/detail',
    component: NotificationDetail,
    meta: {
      layout: 'member',
      title: i18n.t('notification'),
      auth: true
    }
  },
  {
    name: 'Notifications Region',
    path: '/notifications/region',
    component: NotificationRegionList,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.doctorInfo.region_id) {
        next()
      }
      else {
        next('/404')
      }
    },
    meta: {
      layout: 'member',
      title: i18n.t('notification'),
      auth: true
    }
  },
  {
    name: 'Notifications Region Detail',
    path: '/notifications/region/:id',
    component: NotificationRegionDetail,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.doctorInfo.region_id) {
        next()
      }
      else {
        next('/404')
      }
    },
    meta: {
      layout: 'member',
      title: i18n.t('notification'),
      auth: true
    }
  },
  {
    name: 'Notifications ',
    path: '/notifications/management',
    component: NotificationManagement,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.doctorInfo.region_id && parseInt(store.state.auth.doctorInfo.region_authority) == 1) {
        next()
      }
      else {
        next('/404')
      }
    },
    meta: {
      layout: 'member',
      title: i18n.t('notification_management'),
      auth: true
    }
  },
  {
    name: 'New Notification',
    path: '/notifications/management/new',
    component: NotificationForm,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.doctorInfo.region_id && parseInt(store.state.auth.doctorInfo.region_authority) == 1) {
        next()
      }
      else {
        next('/404')
      }
    },
    meta: {
      layout: 'member',
      title: i18n.t('notification_management'),
      auth: true
    }
  },
  {
    name: 'Edit Notification',
    path: '/notifications/management/edit/:id',
    component: NotificationForm,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.doctorInfo.region_id && parseInt(store.state.auth.doctorInfo.region_authority) == 1) {
        next()
      }
      else {
        next('/404')
      }
    },
    meta: {
      layout: 'member',
      title: i18n.t('notification_management'),
      auth: true
    }
  },
  {
    name: 'LegalTermsofuse',
    path: '/legal/termsofuse',
    component: LegalTermsofuse,
    meta: {
      layout: store.state.auth.token ? 'member' : 'default',
      title: i18n.t('terms_of_service'),
      auth: undefined
    }
  },
  {
    name: 'Info',
    path: '/info',
    component: Info,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.typeOfUser === 'pharmacy') {
        next(from.path)
      }
      else {
        next()
      }
    },
    meta: {
      layout: store.state.auth.token ? 'member' : 'default',
      title: i18n.t('about_service'),
      auth: undefined
    }
  },
  {
    name: 'Settings',
    path: '/settings',
    component: Settings,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.typeOfUser === 'pharmacy') {
        next('/')
      }
      next()
    },
    meta: {
      layout: 'member',
      title: i18n.t('configuration'),
      auth: true
    }
  },
  {
    path: '/404',
    component: NotFound,
    meta: {
        title: "Doctor | 404",
        auth: undefined
    }
  },
  {
    name: 'SurveyComplete',
    path: '/survey-complete',
    component: SurveyComplete,
    meta: {
      layout: 'nonmember',
      title: "Survey Complete",
      auth: undefined,
    }
  },
  {
    name: 'Survey',
    path: '/survey',
    component: Survey,
    meta: {
      layout: 'nothing',
      title: i18n.t('survey'),
      auth: true
    }
  },
  {
    name: 'ErrorCheck',
    path: '/error-check',
    component: ErrorCheck,
    meta: {
      layout: store.state.auth.token ? 'member' : 'default',
      title: "Error Check",
      auth: undefined,
    }
  },

  {
    name: 'Maintenance',
    path: '/maintenance',
    component: MaintenanceMode,
    meta: {
      layout: 'nothing',
      title: "Maintenance",
    }
  },
  {
    name: 'Change Email',
    path: '/change-email',
    component: ChangeEmailForm,
    meta: {
      layout: 'member',
      auth: true,
      title: "Change Email"
    }
  },
  {
    name: 'Confirm Change Email',
    path: '/confirm-change-email',
    component: ConfirmChangeEmail,
    beforeEnter: (to, from, next) => {
      if (!store.state.auth.emailChange.email) {
        next('/change-email')
      }
      next()
    },
    meta: {
      layout: 'member',
      auth: true,
      title: "Confirm Change Email"
    }
  },
  {
		name: 'Register Phone Number',
		path: '/register-phone-number',
		component: RegisterPhoneNumber,
		meta: {
			layout: 'member',
			title: '電話番号登録',
			auth: true,
		}
	},
  {
		name: 'Confirm Phone Number',
		path: '/confirm-phone-number',
		component: ConfirmPhoneNumber,
		meta: {
			layout: 'member',
			title: 'Confirm resgiter phone number',
			auth: true,
		}
	},
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "active"
})

let title = ''

async function loginFromPharmacyNanamedi(to, next) {
  store.dispatch('otp/initLogout')
  store.dispatch('auth/logout')
  let errorMsg = false
    const params = {
        token: to.query.token,
        refresh_token: to.query.refresh_token
    }
    await store.dispatch('auth/login', params)  
    .then( res => {
      title = 'nanacara for Pharmacy'
    })
    .catch(error => {
      if (error.response.status === 401) {
        errorMsg = error.response.data.message
      }
      else if (error.response.status === 422) {
        errorMsg = error.response.data["Request validation error"].token[0] || error.response.data["Request validation error"].refreshToken[0]
      } else {
        errorMsg = i18n.t('not_connected_to_the_network')
      } 
      Vue.dialog
      .alert(
        errorMsg, 
        {
          okText: 'OK',
          backdropClose: true,
          customClass: 'login-required'
        }
      )
      .then(function() {
        next('/login')
      })
    })
    if(!errorMsg && to.query.hasOwnProperty("children_id")) {
      next({ path: 'patient/' + to.query.children_id })
    }
    else {
      next('/patients')
    }
}

async function loginFromDoctorNanamedi(to, next) {
  let errorMsg = false
  const params = {
      token: to.query.dr_token,
      refresh_token: to.query.refresh_token,
      device_token: store.state.auth.fcmToken,
      access_token: store.state.auth.access_token,
  }
  await store.dispatch('auth/loginFromDrNanamedi', params) 
  .then( res => {
    errorMsg = store.state.auth.errorLogin ? store.state.auth.errorLogin : false
  })
  .catch(() => {})
  if(!errorMsg) {
    await store.dispatch('auth/getDoctorInfo')
    next(to.path)
  }
  else {
    Vue.dialog
    .alert(
      errorMsg, 
      {
        okText: 'OK',
        backdropClose: true,
        customClass: 'login-required'
      }
    )
    .then(function() {
      next('/login')
    })
  }
}

router.beforeEach(async(to, from, next) => {
  // Check if web app is under maintenance
  if (store.state.maintenance.isMaintenance) {
    if (to.name !== 'Maintenance') {
      next({ name: "Maintenance" })
    } else {
      next()
    }
  }

  if(!isTokenExemptPage(to.path) && (window.localStorage.getItem('isLogout') === 'true')) {
    store.dispatch("auth/logout")
    next('/login')
  }
  title = to.meta.title
  //handle when login with token from pharmacy nanamedi
  if(to.query.hasOwnProperty("token") && to.query.hasOwnProperty("refresh_token")) {
    await loginFromPharmacyNanamedi(to, next)  
  }
  else if (to.query.hasOwnProperty("dr_token") && to.query.hasOwnProperty("refresh_token")) {
    await loginFromDoctorNanamedi(to, next)
  }
  // if (isRefreshToken()) {
  //   let refreshToken = store.state.auth.refreshToken
  //   const params = {
  //     refreshtoken: refreshToken
  //   }
  //   await store.dispatch('auth/refreshToken', { params })
  //     .then(() => {})
  //     .catch((error) => {console.log(error)})
  //   if (to.path === '/login') {
  //     to.query.hasOwnProperty("continue") ? next(decodeURIComponent(to.query.continue)) : next('/')
  //   } else {
  //     next()
  //   }
  // }
  if (isLogout()) {
    if (to.meta.auth === true) {
      to.path !== '/' ? next('/login?continue='+encodeURIComponent(to.fullPath)) : null
    }
    if(to.meta.auth === undefined && to.path !== '/login') {
      if (to.name === 'Maintenance')
        to.meta.layout = 'nothing'
      else
        to.meta.layout = 'default'
    }
  }
  document.title = title
  next()
})

export default router
